import { useBlockNoteEditor, useComponentsContext } from "@blocknote/react";

import UIcon from "lib/icons/untitled_ui/UIcon";

export default function AddImageButton() {
  const editor = useBlockNoteEditor();
  const Components = useComponentsContext();

  if (!Components) {
    return <></>;
  }

  return (
    <Components.FormattingToolbar.Button
      label=""
      icon={<UIcon icon="image04" />}
      mainTooltip="Add image"
      onClick={() => {
        const currentBlock = editor.getTextCursorPosition().block;
        editor.insertBlocks([{ type: "image" }], currentBlock, "after");
      }}
    />
  );
}
